import Vue from 'vue'

import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

import Vuetify from 'vuetify/lib'
import fr from 'vuetify/src/locale/fr'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  lang: {
    locales: { fr },
    current: 'fr'
  },
  theme: {
    dark: false,
    themes: {
      light: {
        'primary': '#ff3434',
        'secondary': '#424242',
        'third': '#1976D2',
        'twitter': '#55acee',
        'facebook': '#3b5998',
        'google-plus': '#dd4b39',
        'youtube': '#ff0000',
        'butterfly': '#ee4d9b'
      }
    }
  }
})
